// extracted by mini-css-extract-plugin
module.exports = {"item":"UserAvatar_item__rH_Hs","active":"UserAvatar_active__1sDKH","initials":"UserAvatar_initials__Y4GN0"};